import requestApi from '@/common/http.js'
import apiHelper from '@/common/api.js'
import config from '@/config/index.js'

class Login {
  /**
   * 通行证登录
   *
   * @param {Object} data   登录参数
   */
  add(data) {
    // 定义接口地址
    const url = '/login'

    // 定义接口预期参数
    const paramsExpected = {
      loginid: String,
      smsCode: String,
      wechatGetPhoneNumberCode: String,
      sessid: String
    }

    Object.assign(data, {
      appid: config.appId
    })

    const headers = {}
    if (data.sessid) {
      headers['X-Yf-Sessid'] = data.sessid
    }

    // 对参数进行验证后请求接口
    return apiHelper.prepareParameters(data, paramsExpected).then(() => {
      return requestApi({
        url,
        method: 'post',
        data,
        headers
      })
    })
  }
}

export default new Login()
